import React, { useEffect, useState, useRef, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { scrollBar } from "../../../Common/Header/ManageOutsideClickClose";
import { useDispatch, useSelector } from "react-redux";

import ButtonElement from "../../../UI/Button";
import { getTableSkeletons } from "../../../UI/Skeleton/Loader";

import images from "../../../../Assets/images";
import MaterialSelect from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { setLoader } from "../../../../Store/Actions/Loader/LoaderActionCreator";

import MonthlyUsageModel from "../../../Common/Modal/MonthlyUsageModel";
import {
  GetEquipmentListParams,
} from "Network/Core/EquipmentMaster/types";
import { useApiCall } from "Hooks/useApiCall";
import { getLocalStorage } from "Network/ApiService";
import { ls_vars } from "Library/Constants";
import DeleteConfirmationModal from "Components/Common/Modal/DeleteConfirmationModal";
import {
  deleteEquipmentUsage,
  downloadEquipmentUsageReports,
  listEquipmentUsage,
} from "Network/Core/EquipmentMaster/equipmentUsage";
import { convertVolume, extractNumber, handleError } from "Library/Utils";
import toast from "react-hot-toast";
import SideWindowTopData, { InfoItemProps } from "./SideWindowTopData";
import Pagination from "Components/UI/Pagination/Pagination";
import { getListOfEquipmentRegistry } from "Network/Core/EquipmentMaster/equipmentRegistry";
import { useRolePermission } from "Hooks/useRolePermission";
import { useTranslationCheck } from "Hooks/useTranslationCheck";

function index() {
  const [isScrolling, setIsScrolling] = useState<boolean>(false);
  const { t, tCheck } = useTranslationCheck();
  const { call } = useApiCall();
  const dispatch = useDispatch();
  const { checkPermission } = useRolePermission();

  const project = getLocalStorage(ls_vars.PROJECT_DATA);
  const site = getLocalStorage(ls_vars.PROJECT_SITE_ID);
  const region = getLocalStorage(ls_vars.REGION_ID);
  const [searchValue, setSearchValue] = useState<string>("");
  const [pageCount, setPageCount] = useState<number>(0);
  const [page, setPage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(10);
  const [showSideWindow, setShowSideWindow] = useState(false);

  const isLoading = useSelector((state: any) => state.loader.loading);

  const [orderBy, setOrderBy] = useState<string>("-created_at");
  const [statusIsASC, setStatusIsASC] = useState<boolean>(true);
  const [isaddmonthlyusageModalOpen, setIsaddmonthlyusageModalOpen] =
    useState<boolean>(false);
  const [isConfirmModalShow, setIsConfirmModalShow] = useState<boolean>(false);
  const [existingData, setExistingData] = useState<any>({} as any);
  const [equipmentToBeDeleted, setEquipmentToBeDeleted] = useState<any>();
  const [equipmentUsageData, setEquipmentUsageData] = useState<any[]>([]);
  const [equipmentTypesOptions, setEquipmentTypesOptions] = useState<
    { label: string; value: string; ref: string }[]
  >([]);
    
  const canCreateEquipmentUsage = checkPermission(["equipment:usage:create"]);
  const canUpdateEquipmentUsage = checkPermission(["equipment:usage:update"]);
  const canDeleteEquipmentUsage = checkPermission(["equipment:usage:delete"]);
  const canApproveEquipmentUsage = checkPermission(["equipment:usage:approve"]);
  const canViewEquipmentUsageAttachment = checkPermission(["equipment:usage:attachment:view"]);


  const [sideWindowItems, setSideWindowItems] = useState<InfoItemProps[]>([]);
  const [isUploadFileVisible, setIsUploadFileVisible] =
    useState<boolean>(false);
  const countryUom = getLocalStorage(ls_vars.COUNTRY_UOM);
  scrollBar(setIsScrolling);

  // Generate years (10 years before and after current year)
  const generateYearOptions = () => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = currentYear - 10; year <= currentYear + 10; year++) {
      years.push({ value: year, label: year.toString() });
    }
    return years;
  };

  // Generate months
  const monthOptions = [
    { value: "January", label: "January" },
    { value: "February", label: "February" },
    { value: "March", label: "March" },
    { value: "April", label: "April" },
    { value: "May", label: "May" },
    { value: "June", label: "June" },
    { value: "July", label: "July" },
    { value: "August", label: "August" },
    { value: "September", label: "September" },
    { value: "October", label: "October" },
    { value: "November", label: "November" },
    { value: "December", label: "December" },
  ];
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");

  const yearOptions = generateYearOptions();

  const handlePageClick = (data: { selected: number }) => {
    dispatch(setLoader(true));
    const { selected } = data;
    setPage(selected + 1);
  };

  const handleEquipmentDetails = (data: any) => {
    //API CALL and set the unique key to fetch table data here

    setShowSideWindow(true);

    const items: InfoItemProps[] = [
      { title: "id", value: data.id || 0 },
      { title: "Equipment Name", value: getEquipmentName(data)?.label || "" },
      { title: "Company", value: data.company || "" },
      { title: "Month", value: data.month },
      { title: "Year", value: data.year },
      { title: "No.Of Hours", value: data.noOfHours },
      { title: "Liters/Gallons", value: data.litresOrGallons },
    ];

    setSideWindowItems(items);
  };

  const onChangePage = (e: { value: number }) => {
    setPerPage(e.value);
  };

  // Handle search input change
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchValue(value);
    // debouncedSearchValue(value);
  };

  const getEquipmentUsageDetails = useCallback(async () => {
    dispatch(setLoader(true));

    try {
      let localPageCount = page;
      if ((searchValue || selectedYear || selectedMonth) && page !== 1) {
        localPageCount = 1;
        setPage(1);
      }

      const params: GetEquipmentListParams = {
        page: localPageCount,
        pageSize: perPage,
        search: searchValue,
        orderBy: orderBy,
        project: project.ref,
        year: selectedYear,
        month: selectedMonth,
        site: site
      };

      const res = await listEquipmentUsage(params, region);

      const { status, data, statusText } = res;
      switch (status) {
        case 200:
          setEquipmentUsageData(data?.results);
          const calculatedPages = Math.ceil(data?.count / perPage);
          setPageCount(data?.totalPages || calculatedPages);
          break;
        case 400:
          handleError(data, t);
          break;
        default:
          toast.error(statusText);
          break;
      }
    } catch (err) {
      toast.error(t("Translation.error_something_went_wrong"));
    } finally {
      dispatch(setLoader(false));
    }
  }, [
    dispatch,
    page,
    perPage,
    orderBy,
    searchValue,
    selectedYear,
    selectedMonth,
    t,
  ]);

  useEffect(() => {
    getEquipmentUsageDetails();
  }, [getEquipmentUsageDetails, selectedMonth, selectedYear, searchValue]);

  const handleAddEquipment = () => {
    setExistingData({} as any);
    setIsaddmonthlyusageModalOpen(true);
  };

  const handleEquipmentModalClose = () => {
    setIsaddmonthlyusageModalOpen(false);
    getEquipmentUsageDetails();
  };

  const fetchEquipmentTypes = async () => {
    call(
      () => getListOfEquipmentRegistry(region, project.ref, site),
      (res: any) => {
        const options = res?.results?.map((item: any) => ({
          label: `[${item.scheduledArrival}]-${item.equipmentType}-${item.company}-${item.regMake}-${item.regModel}-${item.regYear}`,
          value: item.id,
          ref: item.ref,
        }));

        setEquipmentTypesOptions(options);
      }
    );
  };

  const handleDeleteEquipment = async (equipment: any) => {
    if (!equipment || equipment.id === undefined) {
      console.error("Cannot delete equipment: Invalid ID");
      return;
    }
    call(
      () => deleteEquipmentUsage(equipment.id, region, project.ref),
      (res: any) => {
        closeConfirmationModal();
        getEquipmentUsageDetails();
      },
      {
        successMessage: "Translation.equipment_usage_delete_success",
        onError: (error) => {
          if (error?.error) toast.error(t(`Translation.${error.error}`));
          else if (error) toast.error(t(`Translation.${error}`));
        },
      }
    );
  };

  const closeConfirmationModal = () => {
    setIsConfirmModalShow(false);
  };

  const toggleSort = (field: string, isAcs: boolean) => {
    if (field !== "id") {
      setStatusIsASC(!isAcs);
      setOrderBy(isAcs ? field : "-" + field);
    }
  };

  const getEquipmentName = (data: any) => {
    return equipmentTypesOptions.find(
      (e) => e.value === data.registeredEquipment
    );
  };

  // Handler for year change
  const handleYearChange = async (e: any) => {
    setSelectedYear(e.target.value);
  };

  // Handler for month change
  const handleMonthChange = async (e: any) => {
    setSelectedMonth(e.target.value);
  };

  const handleClearFilters = () => {
    setSelectedYear("");
    setSelectedMonth("");
    setSearchValue("");
    getEquipmentUsageDetails();
  };

  scrollBar(setIsScrolling);

  useEffect(() => {
    fetchEquipmentTypes();
  }, []);

  const exportReportData = async () => {
    call(
      () =>
        downloadEquipmentUsageReports(
          {
            orderBy: orderBy,
            search: searchValue,
            year: selectedYear,
            month: selectedMonth,
            site: site,
          },
          region,
          project.ref
        ),
      undefined,
      {
        successMessage: "Translation.equipment_usage_report_download_success",
        onError: (error) => {
          console.error("Eqp Usage down : error: ", error);
        },
      }
    );
  };

  return (
    <>
      {isaddmonthlyusageModalOpen && (
        <>
          <MonthlyUsageModel
            handleClose={() => handleEquipmentModalClose()}
            existingData={existingData}
          />
          <div className="modal-backdrop fade show" />
        </>
      )}
      {isConfirmModalShow && (
        <DeleteConfirmationModal
          isOpen={isConfirmModalShow}
          contentName={"EquipmentUsage"}
          deleteContent={"EquipmentUsageDelete"}
          closeModal={closeConfirmationModal}
          onConfirmAction={() => handleDeleteEquipment(equipmentToBeDeleted)}
        />
      )}

      <div className="page-wrapper pb-0">
        <div className="page-header">
          <h3 className="page-title">
            {t("Translation.equipment_monthly_usage_capture")}
          </h3>
        </div>
        <div className="page-content custom-list-div">
          <div className="user-head-sec">
            <div className="booking-list-form">
              <div className="filter-wrapper">
                <div className="f-left" style={{ alignItems: "baseline" }}>
                  <div style={styles.filterContainer} className="px-3 pb-4">
                    <MaterialSelect
                      value={selectedYear}
                      onChange={(e) => handleYearChange(e)}
                      displayEmpty
                      sx={styles.selectStyle}
                    >
                      <MenuItem value="" disabled>
                        {t("Translation.year")}
                      </MenuItem>
                      {yearOptions.map((item) => (
                        <MenuItem value={item.value} key={item.value}>
                          {tCheck(item.label)}
                        </MenuItem>
                      ))}
                    </MaterialSelect>

                    <MaterialSelect
                      value={selectedMonth}
                      onChange={(e) => handleMonthChange(e)}
                      displayEmpty
                      sx={styles.selectStyle}
                    >
                      <MenuItem value="" disabled>
                        {t("Translation.month")}
                      </MenuItem>
                      {monthOptions.map((item) => (
                        <MenuItem value={item.value} key={item.value}>
                          {tCheck(item.label)}
                        </MenuItem>
                      ))}
                    </MaterialSelect>

                    <ButtonElement
                      buttonLabel={t("Translation.clear_filters")}
                      handleClick={handleClearFilters}
                      className="btn btn-outline-danger"
                    />
                  </div>
                  <div className="form-group form-inline filter-search ml-0">
                    <img src={images.search} />
                    <input
                      type="text"
                      className="form-control"
                      placeholder={t("Translation.search")}
                      value={searchValue}
                      onChange={handleSearchChange}
                    />
                  </div>

                  {canCreateEquipmentUsage && (
                    <ButtonElement
                      buttonLabel={t(
                        "Translation.add_equipment_monthly_usage_capture"
                      )}
                      handleClick={handleAddEquipment}
                      className="btn theme-btn invite-btn"
                    />
                  )}
                </div>
              </div>
            </div>

            <div className="f-right d-flex" style={{ gap: "5px" }}>
              <div>
                <img
                  src={images.download_ic}
                  style={styles.downloadBtn}
                  onClick={exportReportData}
                />
              </div>
            </div>
          </div>
          <div className="booking-list-wrapper">
            <div
              className={`booking-list-data scroll ${
                isScrolling ? "show-scroll" : "no-scroll"
              }`}
              style={{
                flex: "1 1 0%",
                overflow: "auto",
                padding: "0px 24px 24px",
              }}
            >
              <div className="tab-content" id="pills-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="pills-all"
                  role="tabpanel"
                  aria-labelledby="pills-all-tab"
                >
                  <div className="table-responsive">
                    {isLoading ? (
                      getTableSkeletons({
                        cols: 6,
                        rows: 3,
                        props: {
                          TableRowProps: {
                            style: { height: "75px" },
                          },
                        },
                      })
                    ) : (
                      <table className="display nowrap dataTable w-100">
                        <thead>
                          <tr>
                            <th
                              className="sorting sorting_asc"
                              onClick={() =>
                                toggleSort(
                                  "registered_equipment__ref",
                                  statusIsASC
                                )
                              }
                            >
                              <span>{`${t("Translation.equipment_reference")}`}</span>
                            </th>
                            <th
                              className="sorting sorting_asc"
                              onClick={() =>
                                toggleSort("registered_equipment", statusIsASC)
                              }
                            >
                              <span>{`${t("Translation.equipment_name")}`}</span>
                            </th>
                            <th
                              className="sorting"
                              onClick={() => toggleSort("company", statusIsASC)}
                            >
                              <span>{t("Translation.company")}</span>
                            </th>
                            <th
                              className="sorting"
                              onClick={() => toggleSort("month", statusIsASC)}
                            >
                              <span>{t("Translation.month")}</span>
                            </th>
                            <th
                              className="sorting"
                              onClick={() => toggleSort("year", statusIsASC)}
                            >
                              <span>{t("Translation.year")}</span>
                            </th>
                            <th
                              className="sorting"
                              onClick={() =>
                                toggleSort("no_of_hours", statusIsASC)
                              }
                            >
                              <span> {t("Translation.no_of_hours")}</span>
                            </th>
                            <th
                              className="sorting"
                              onClick={() =>
                                toggleSort("litres_or_gallons", statusIsASC)
                              }
                            >
                              <span>
                                {t(
                                  countryUom?.volume?.name === "Gallons"
                                    ? "Translation.gallons"
                                    : "Translation.litres"
                                )}
                              </span>
                            </th>

                            <th>{t("Translation.actions")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {equipmentUsageData ? (
                            equipmentUsageData?.map((equipmentUsage) => (
                              <tr key={equipmentUsage.id}>
                                <td>{getEquipmentName(equipmentUsage)?.ref}</td>
                                <td>
                                  {getEquipmentName(equipmentUsage)?.label}
                                </td>
                                <td>{equipmentUsage.company}</td>
                                <td>{equipmentUsage.month}</td>
                                <td>{equipmentUsage.year}</td>
                                <td>{equipmentUsage.noOfHours}</td>
                                <td>
                                  {(() => {
                                    const volumeValue = equipmentUsage.litresOrGallons;
                                    if (!volumeValue) return "0.00";
                                    return convertVolume(
                                          extractNumber(volumeValue.toString()),
                                          getLocalStorage(ls_vars.COUNTRY_UOM)
                                        );
                                  })()}
                                </td>
                                <td>
                                  <div className="action-buttons">
                                    {canUpdateEquipmentUsage && (
                                      <button
                                        className="btn bg-transparent border-0"
                                        onClick={() => {
                                          setExistingData(equipmentUsage);
                                          setIsaddmonthlyusageModalOpen(true);
                                        }}
                                      >
                                        <img src={images.edit} alt="edit" />
                                      </button>
                                    )}
                                    {canDeleteEquipmentUsage && (
                                      <button
                                        className="btn bg-transparent border-0"
                                        onClick={() => {
                                          setEquipmentToBeDeleted(
                                            equipmentUsage
                                          );
                                          setIsConfirmModalShow(true);
                                        }}
                                      >
                                        <img
                                          src={images.DeleteRedIcon}
                                          alt="view"
                                        />
                                      </button>
                                    )}
                                    {canViewEquipmentUsageAttachment && (
                                      <button
                                        className="btn bg-transparent border-0"
                                        onClick={() => {
                                          handleEquipmentDetails(
                                            equipmentUsage
                                          );
                                        }}
                                      >
                                        <img src={images.file} alt="upload" />
                                      </button>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={7} className="text-center">
                                {t("Translation.no_equipment_found")}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                  </div>

                  {equipmentUsageData && equipmentUsageData.length > 0 ? (
                    <Pagination
                      page={page}
                      onPageChange={(v) => setPage(v)}
                      perPage={perPage}
                      onPerPageChange={({ value }) => setPerPage(value)}
                      pageTotalCount={pageCount}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>

            {showSideWindow && sideWindowItems && (
              <div>
                <SideWindowTopData
                  items={sideWindowItems}
                  isOpen={showSideWindow}
                  onClose={() => setShowSideWindow(false)}
                  handleclose={() => setShowSideWindow(false)}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default index;

const styles = {
  downloadBtn: {
    cursor: "pointer",
  },
  headerStyle: {
    backgroundColor: "#EFF3F6",
    color: "#5A5A5A",
  },
  filterContainer: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr",
    gap: "14px",
  },
  selectStyle: {
    width: "100%",
    height: "48px",
    background: "#EFF3F6",
    color: "#A0AEBD",
    border: "none",
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
  },
  dateRangeContainer: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gap: "14px",
  },
  datePickerWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  lastColumnWrapper: {
    display: "flex",
    justifyContent: "flex-end", // or 'flex-end' if you only want the button
    alignItems: "center",
  },
  dateRangeSeparator: {
    marginLeft: "10px",
    marginRight: "10px",
  },
  dateBoxContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
  },
  searchImage: {
    // top: "14px" as "14px",
    position: "relative" as "relative",
    height: "20px",
    width: "20px",
    left: "30px" as "30px",
  },
  searchBox: {
    height: "45px" as "45px",
    width: "70%" as "70%",
    paddingLeft: "25px" as "25px",
    background: "#EFF3F6" as "#EEF3F6",
    border: "none" as "none",
  },
  tableHeader: {
    backgroundColor: "#EFF3F6",
    color: "#5A5A5A",
    "& th": {
      padding: "12px",
    },
  },
  tableRow: {
    "& td": {
      padding: "12px",
    },
  },
};
